import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import DetallePartesScreen from './screen';
import { PartesAdapter, Parte, FiltroPartes } from '../../../../../infraestructure/persistence/rest/PartesAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { UsuariosAdapter } from '../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { AdjuntosAdapter } from '../../../../../infraestructure/persistence/rest/AdjuntosAdapter';
import { downloadFile } from '../../../../../shared/utils/download';
//import { useProfile } from '../../../../../shared/hooks/Profile';

const DetallePartesContainer = (props:any) => {
	const api = new PartesAdapter();
	const apiUser = new UsuariosAdapter();
	const apiAdjuntos = new AdjuntosAdapter();
	const pantalla = 'detallepartes';
	const {resultError, exceptionError, launchNotification} = useNotifications();
	//const {profile} = useProfile();

	let [ data, setData ] = useState<any>([]);
	let [columnsUser, setColumnsUser] = useState<any>(undefined);
	let [isLoading, setIsLoading] = useState(false)
	let result: any;

	useEffect(() => {getColumnConfig()}, []);
	useEffect(() => setIsLoading(false), [ data ]);

	const getColumnConfig =async (dni?:string) =>{
		try {
			result = await apiUser.GetColumnasUsuario();
			if(result.data && result.data!=="")
			{
			  const columnas = (result.data[0] && JSON.parse(result.data[0].columnas).pantallas.filter((f:any)=> f.pantalla === pantalla)[0])
			  return setColumnsUser(columnas!==undefined ? columnas.columnas : undefined)
			}else{resultError()}
		  } catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		  }
	}

	const getPartes = async (filtro: FiltroPartes ) => {
		setIsLoading(true);
		//filtro.perfil = profile;
		try {
			result = await api.ListarDetallePartes(filtro);
			if(result.data && result.data!=="")
			{
				setData([ ...(result.data || []) ]);
			}else{resultError();setIsLoading(false);}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception);
			setIsLoading(false);
		}
	};

	const downloadAllAdjuntos = async (filtro: FiltroPartes ) => {
		const {fechaDesde,fechaHasta} = filtro;
		setIsLoading(true);
		try {
			const _request = {fechaDesde:fechaDesde, fechaHasta:fechaHasta};
			result = await apiAdjuntos.DescargarAdjuntos(_request);
			if(result.data && result.data!=="")
			{
				const fileName = `Adjuntos Partes_${fechaDesde}_${fechaHasta}.zip`
				await downloadFile(result.data,fileName)
				setIsLoading(false);
			}else{resultError();setIsLoading(false);}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception);
			setIsLoading(false);
		}
	};

	const downloadAdjuntosPartes = async (ids:string, filename:string ) => {
		setIsLoading(true);
		try {
			const _request = {fechaDesde:null, fechaHasta:null, idPartes:ids};
			result = await apiAdjuntos.DescargarAdjuntos(_request);
			if(result.data && result.data!=="")
			{
				const _nameFile = `${filename===null||filename===''?'Adjuntos Partes' : filename}.zip`
				await downloadFile(result.data,_nameFile)
				setIsLoading(false);
			}else{resultError();setIsLoading(false);}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception);
			setIsLoading(false);
		}
	};

	return(
		<DetallePartesScreen
			data={data}
			columnsUser={columnsUser}
			handleFilter={getPartes}
			handleDownloadAllAdjuntos={downloadAllAdjuntos}
			handleDownloadAdjuntosPartes={downloadAdjuntosPartes}
			isLoading={isLoading}
		/>
	);
};

export default DetallePartesContainer;
